import axios from 'axios'

export default class ListaMunicipios {
  constructor (tokenBearer, url) {
    this.url = `${url}/api/unimed/enderecos/municipios`
    this.tokenBearer = tokenBearer
  }

  getMunicipio (idEstado = 35) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: `${this.url}/${idEstado}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  getAllMunicipios () {
    return new Promise(async (resolve, reject) => {
      const options = {
        method: 'get',
        url: this.url,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let res = await axios(options)
        resolve(res)
      } catch (err) {
        reject(err)
      }
    })
  }
}
